import { coreActions } from '@sonar-software/sonar-core';
import { useAction } from '@hooks';
import { Col, Row } from 'antd';
import { InitiativeOwnersSummary, InitiativeScopeSummary, InitiativeStakeholdersSummary, InitiativeTasksSummary } from '.';
import React, { useEffect } from 'react';
export const InitiativeSummary = ({ initiativeId }) => {
    const getSummary = useAction(coreActions.requestGetCoreInitiativesSummary);
    useEffect(() => {
        if (initiativeId) {
            getSummary({ initiativeId });
        }
    }, [getSummary, initiativeId]);
    return (React.createElement("div", { id: 'initiative-summary' },
        React.createElement(InitiativeScopeSummary, { initiativeId: initiativeId }),
        React.createElement(InitiativeTasksSummary, { initiativeId: initiativeId }),
        React.createElement(Row, { gutter: 32 },
            React.createElement(Col, null,
                React.createElement(InitiativeOwnersSummary, { initiativeId: initiativeId })),
            React.createElement(Col, null,
                React.createElement(InitiativeStakeholdersSummary, { initiativeId: initiativeId })))));
};
